"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.FormFieldsBox = void 0;

var _react = _interopRequireDefault(require("react"));

var _styleModule = _interopRequireDefault(require("./style.module.scss"));

var _jsxRuntime = require("react/jsx-runtime");

/**
 * Funnel form fields component
 **/
var FormFieldsBox = function FormFieldsBox(_ref) {
  var children = _ref.children;
  return /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
    className: _styleModule.default.box,
    children: children
  });
};

exports.FormFieldsBox = FormFieldsBox;
var _default = FormFieldsBox;
exports.default = _default;